import React from "react";
import contextProvider from "../../contextProvider";
import { withRouter, Link } from "react-router-dom";
import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";
import ReactOTooltip from "../../_L1_components/Elements/ReactOTooltip";
import ReactOCollapse from "../../_L1_components/Elements/ReactOCollapse";

class RowSpanTable extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      data: {},
      _collapse_controllers: {},
    };
    super(props, initState);
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.apiStore = this.getAppContext().getApiStoreService();
    console.log(this.props.data);
    //	this.loadProbeUsers();
  }

  onComponentWillUnmount() {}

  onRender() {
    return (
      <div>
        {this.getAppContext().media.isMobile ? (
          Object.keys(this.props.data)
            .reverse()
            .map((time, id) => (
              <div key={id} className={this.props.rowClass.get(time) + " my-2"}>
                <div className="mx-3">
                  <strong className="sub-title">Time</strong>
                  <div>
                    <strong>
                      {this.getAppContext().momentjs(time, "X").format("L LT")}
                    </strong>
                  </div>
                  {Object.keys(this.props.data[time]).map((probeid, id2) => (
                    <div key={id2} className="mt-2">
                      <div
                        className="d-flex flex-grow-1"
                        onClick={() => {
                          this.state._collapse_controllers[id + probeid + id2].toggle();
                        }}
                      >
                        <div>
                          <strong>{this.props.data[time][probeid].name}</strong>
                          <div>{probeid.replace(/(..)/g, "$1:").slice(0, -1)}</div>
                        </div>

                        <span
                          className={
                            this.state._collapse_controllers &&
                            this.state._collapse_controllers[id + probeid + id2] &&
                            this.state._collapse_controllers[id + probeid + id2].opened ==
                              false
                              ? "d-flex flex-grow-1 icon-caret-up-outline justify-content-end mr-3"
                              : "d-flex flex-grow-1 justify-content-end icon-caret-down-outline mr-3"
                          }
                        ></span>
                      </div>

                      <div>
                        <ReactOCollapse
                          key={id + probeid + id2}
                          onControllerReady={(_collapse_controller) => {
                            this.setState((prev_state) => {
                              prev_state._collapse_controllers[
                                id + probeid + id2
                              ] = _collapse_controller;
                              return prev_state;
                            });
                          }}
                          onOpened={() => {
                            this.setState((prev_state) => {
                              prev_state._collapse_controllers[
                                id + probeid + id2
                              ].opened = true;
                              return prev_state;
                            });
                          }}
                          onClosed={() => {
                            this.setState((prev_state) => {
                              prev_state._collapse_controllers[
                                id + probeid + id2
                              ].opened = false;
                              return prev_state;
                            });
                          }}
                          initOpen={false}
                        >
                          {this.props.data[time][probeid].operations.map(
                            (operation, id_op) => (
                              <div key={id_op} className="mt-3">
                                <strong className="sub-title">Reason</strong>

                                <div>{operation.reason}</div>
                                {Object.keys(operation.aps).map((aps, id_aps) => (
                                  <div key={id_aps}>
                                    <strong className="sub-title mt-1">
                                      Access Point
                                    </strong>

                                    <div className={operation.action.className}>
                                      <strong>
                                        {aps} {operation.action.text}
                                      </strong>
                                    </div>
                                    {Object.keys(operation.aps[aps]).map(
                                      (mac, id_mac) => (
                                        <div
                                          className="text-muted sub-title"
                                          key={id_mac}
                                        >
                                          {" "}
                                          {operation.aps[aps][mac]}: {mac}
                                        </div>
                                      )
                                    )}
                                  </div>
                                ))}
                              </div>
                            )
                          )}
                        </ReactOCollapse>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))
        ) : (
          <div className="d-flex">
            <div className="flex-grow-1 table-responsive-xl">
              <table className="table">
                <thead className="thead-light">
                  <tr>
                    {this.props.cols.map((_th, id) => {
                      return (
                        <th
                          key={_th.data_key}
                          scope="col"
                          className="text-nowrap text-muted dividers px-2 py-1"
                          style={{ width: _th.width + "%" }}
                        >
                          <div className={"d-flex justify-content-" + _th.align}>
                            <small className="">
                              <strong>{_th.title}</strong>
                            </small>
                          </div>
                        </th>
                      );
                    })}
                  </tr>
                </thead>

                <tbody>
                  {this.props.data
                    ? Object.keys(this.props.data)
                        .reverse()
                        .map((time, id) =>
                          Object.keys(this.props.data[time]).map((probeid, id2) =>
                            this.props.data[time][probeid].operations.map(
                              (operation, id3) => {
                                return (
                                  <tr
                                    key={id + id2 + id3}
                                    className={this.props.rowClass.get(time)}
                                  >
                                    {id2 == 0 && id3 == 0 ? (
                                      <td
                                        className="border-right align-middle text-center"
                                        rowSpan={this.props.rowSpan.get(time)}
                                      >
                                        {this.getAppContext()
                                          .momentjs(time, "X")
                                          .format("L LT")}
                                      </td>
                                    ) : null}
                                    {id3 == 0 ? (
                                      <td
                                        className="border-right align-middle text-center"
                                        rowSpan={this.props.data[time][probeid].rowspan}
                                      >
                                        <div>
                                          <Link
                                            to={"/" + probeid + "/active"}
                                            target="_blank"
                                          >
                                            <h5>{this.props.data[time][probeid].name}</h5>
                                            <span className="sub-title">
                                              {probeid
                                                .replace(/(..)/g, "$1:")
                                                .slice(0, -1)}
                                            </span>
                                          </Link>
                                        </div>
                                      </td>
                                    ) : null}
                                    <td className="border-right align-middle text-center">
                                      {operation.reason}
                                    </td>
                                    <td
                                      className={
                                        operation.action.className +
                                        " border-right align-middle text-center"
                                      }
                                    >
                                      {Object.keys(operation.aps).map((aps, id_x) => {
                                        let tp_id =
                                          "_tp_" +
                                          aps
                                            .substring(0, 12)
                                            .replace(/[^0-9a-z]/gi, "") +
                                          "_" +
                                          operation._id;
                                        if (aps == "Top3") {
                                          return (
                                            <div key={id_x}>
                                              "Top3 criteria" {operation.action.text}
                                            </div>
                                          );
                                        } else {
                                          return (
                                            <div key={id_x} id={tp_id}>
                                              {aps} {operation.action.text}
                                              <span>
                                                <ReactOTooltip
                                                  target={tp_id}
                                                  placement="top"
                                                  text={Object.keys(
                                                    operation.aps[aps]
                                                  ).map((mac, id_y) => {
                                                    return (
                                                      <div
                                                        className="text-left"
                                                        key={id_y}
                                                      >
                                                        {operation.aps[aps][mac]}: {mac}
                                                      </div>
                                                    );
                                                  })}
                                                />
                                              </span>
                                            </div>
                                          );
                                        }
                                      })}
                                    </td>
                                  </tr>
                                );
                              }
                            )
                          )
                        )
                    : null}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default contextProvider(withRouter(RowSpanTable), {
  define: null,
});
